var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#20E290",
    fillOpacity: 0.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 32,
    height: 32,
    rx: 16,
    stroke: "#20E290",
    strokeOpacity: 0.1,
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3337 11.5117V14.2654C19.3337 14.6387 19.3337 14.8254 19.4063 14.968C19.4702 15.0935 19.5722 15.1955 19.6977 15.2594C19.8403 15.332 20.027 15.332 20.4003 15.332H23.154M23.3337 16.6575V21.4654C23.3337 22.5855 23.3337 23.1455 23.1157 23.5733C22.9239 23.9497 22.618 24.2556 22.2416 24.4474C21.8138 24.6654 21.2538 24.6654 20.1337 24.6654H15.867C14.7469 24.6654 14.1868 24.6654 13.759 24.4474C13.3827 24.2556 13.0767 23.9497 12.885 23.5733C12.667 23.1455 12.667 22.5855 12.667 21.4654V14.532C12.667 13.4119 12.667 12.8519 12.885 12.4241C13.0767 12.0477 13.3827 11.7418 13.759 11.55C14.1868 11.332 14.7469 11.332 15.867 11.332H18.0082C18.4974 11.332 18.7419 11.332 18.9721 11.3873C19.1762 11.4363 19.3713 11.5171 19.5502 11.6268C19.7521 11.7504 19.925 11.9234 20.2709 12.2693L22.3964 14.3948C22.7423 14.7407 22.9153 14.9136 23.0389 15.1155C23.1486 15.2944 23.2294 15.4895 23.2784 15.6936C23.3337 15.9237 23.3337 16.1683 23.3337 16.6575Z",
    stroke: "#20E290",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/file_icon.0c0084cf306834cc27579e3784198a09.svg";
export { ForwardRef as ReactComponent };